export const SIGNATURE_REQUIREMENT_EVENT = {
  SignAsPayee: "SignAsPayee",
  DownloadAsPayee: "DownloadAsPayee",
  SignAsPayer: "SignAsPayer",
  DownloadAsPayer: "DownloadAsPayer"
} as const;
